import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment/moment';

@Pipe({
  name: 'fromNeutralDate'
})
export class FromNeutralDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return value + (moment().utcOffset() * 60000);
    }
  }

}
